var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroller",attrs:{"data-animated":""}},[_c('ul',{staticClass:"scroller__inner",class:{ 'slow-animation': !_vm.isDesktop, 'fast-animation': _vm.isDesktop }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }